import request from '@/utils/request'
import locale from './../lang/i18n'
import { adminPath, uploadMedia } from './adminV1'

function publicLocale () {
  return locale.locale === 'en-US' ? 'en' : 'zh-cn'
}

function getPublicHome () {
  return request({ url: `/api/public/v1/${publicLocale()}/home`, method: 'get' })
}

export function addBanner (file) {
  return uploadMedia(file, 'image')
    .then(media => request({
      url: adminPath('/home-media/banners'),
      method: 'post',
      data: { url: media.url }
    }))
    .then(data => ({ code: 0, data }))
}

export function deleteBanner (id) {
  return request({ url: adminPath(`/home-media/banners/${id}`), method: 'delete' })
    .then(() => ({ code: 0 }))
}

export function getBannerList () {
  return getPublicHome().then(data => ({ code: 0, data: data.banners || [] }))
}

export function getAdminBannerList () {
  return request({ url: adminPath('/home-media/banners'), method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function addCertify (file) {
  return uploadMedia(file, 'image')
    .then(media => request({
      url: adminPath('/home-media/certifications'),
      method: 'post',
      data: { url: media.url }
    }))
    .then(data => ({ code: 0, data }))
}

export function deleteCertify (id) {
  return request({ url: adminPath(`/home-media/certifications/${id}`), method: 'delete' })
    .then(() => ({ code: 0 }))
}

export function getCertifyList () {
  return getPublicHome().then(data => ({ code: 0, data: data.certifications || [] }))
}

export function getAdminCertifyList () {
  return request({ url: adminPath('/home-media/certifications'), method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function updateCertify (data) {
  return request({
    url: adminPath(`/home-media/certifications/${data.id}`),
    method: 'put',
    data: {
      url: data.url,
      description: data.desc,
      order: data.index
    }
  }).then(result => ({ code: 0, data: result }))
}

export function getIndexImg () {
  return getPublicHome().then(data => ({
    code: 0,
    data: { value1: data.aboutImage, value2: data.newsImage }
  }))
}
